import { t } from '../../i18n'

const scope = 'controls'

export const errorText = (error: any, fallbackKey: string): string =>
  error?.response?.data?.error || t(fallbackKey, { scope })
